var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._l((_vm.chunks),function(chunk,i){return [(i % 2 === 0)?_c('span',{domProps:{"innerHTML":_vm._s(chunk)}}):_vm._t(chunk)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }